import { useMemo } from 'react';

import { useAppSelector } from 'store';
import { mapQueries } from 'utils/query';
import { isAuthCompanyUser } from 'store/slices/auth';
import { useAlert, isMobile, handleMutation } from 'hooks';
import { getLatestChargebackDescription } from 'utils/helpers';
import { useUpdateChargebackMutation } from 'store/api/accounting';
import { useGetTokenQuery, useCaseDetailsQuery } from 'store/api/fiserv';
import {
  Col,
  Row,
  Info,
  Drawer,
  Details,
  InfoBlock,
  DrawerHeader,
} from 'components';

import { Form } from './form';
import * as Styles from './styles';
import { DetailsProps } from './types';
import { getInfoItems } from './config';
import { FiservList } from './fiserv-list';

export const ChargebackDetails = ({ data, opened, onClose }: DetailsProps) => {
  const mobile = isMobile();
  const { showSuccessAlert } = useAlert();
  const isCompanyOwner = useAppSelector(isAuthCompanyUser);
  const infoItems = useMemo(() => {
    const items = getInfoItems(data);
    const description = getLatestChargebackDescription(data);

    return [
      ...items,
      {
        value: description,
        title: 'Action Description',
      },
    ];
  }, [data]);

  const { data: token, ...tokenProps } = useGetTokenQuery();
  const { data: fiservData, ...props } = useCaseDetailsQuery(String(data?.id), {
    skip: !data?.id || !token?.exists,
  });

  const [update, mutation] = useUpdateChargebackMutation();
  handleMutation(mutation);

  return (
    <Drawer topOffset="20%" opened={opened}>
      <DrawerHeader onClose={onClose} title={`Invoice ${data?.checkoutId}`} />

      <Details {...mapQueries([props, tokenProps])}>
        <Styles.Container>
          <InfoBlock>
            <Row>
              {infoItems.map((item, index) => (
                <Col col={2} key={index} colTablet={4}>
                  <Info {...item} />
                </Col>
              ))}
            </Row>
          </InfoBlock>

          {fiservData && fiservData && fiservData.length > 0 && (
            <FiservList data={fiservData} />
          )}

          {isCompanyOwner && (
            <Form
              data={data}
              update={update}
              mobile={mobile}
              onClose={onClose}
              showSuccessAlert={showSuccessAlert}
            />
          )}
        </Styles.Container>
      </Details>
    </Drawer>
  );
};
